import contract from '@mailobj-browser/front/js/contracts/contract.js'
import closeMenu from './closeMenu/closeMenu.js'
import array from '@mailobj-browser/front/js/utils/array.js'

export default contract({
    closeMenu: array([
        closeMenu
    ]),
})